/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Lifecycle of a publisher's monthly royalty report.
 *
 * ``DRAFT`` is the only refreshable state — the scheduler keeps it in step
 * with the aggregate. Everything past it is frozen: a drifting amount does
 * not edit a sent report, it opens a new version that starts at ``DRAFT``
 * again. ``SENT`` and ``SKIPPED`` are the platform's moves, ``APPROVED`` and
 * ``REJECTED`` the publisher's.
 *
 * ``SKIPPED`` is terminal and reachable from ``DRAFT`` alone: it says "this
 * month is not being settled with this publisher", so the scheduler leaves it
 * alone for good — a later drift must not resurrect it as a fresh draft.
 */
export type RoyaltyReportStatus = typeof RoyaltyReportStatus[keyof typeof RoyaltyReportStatus];


export const RoyaltyReportStatus = {
  draft: 'draft',
  sent: 'sent',
  skipped: 'skipped',
  approved: 'approved',
  rejected: 'rejected',
} as const;
